export const config = {
        BACKEND_URL:            process.env.REACT_APP_BACKEND_PROTOCOL +
                                process.env.REACT_APP_BACKEND_HOST +
                                process.env.REACT_APP_BACKEND_PORT,
        KEYMAKER:               process.env.REACT_APP_KEYMAKER_URL_PROTOCOL +
                                process.env.REACT_APP_KEYMAKER_URL_HOST +
                                process.env.REACT_APP_KEYMAKER_URL_PORT,
        GRIPHOOK_BACKEND_URL:   process.env.REACT_APP_GRIPHOOK_BACKEND_PROTOCOL +
                                process.env.REACT_APP_GRIPHOOK_BACKEND_HOST +
                                process.env.REACT_APP_GRIPHOOK_BACKEND_PORT,
        ERISED_BACKEND_URL:     process.env.REACT_APP_ERISED_BACKEND_PROTOCOL +
                                process.env.REACT_APP_ERISED_BACKEND_HOST +
                                process.env.REACT_APP_ERISED_BACKEND_PORT,
        BOILER_BACKEND_URL:     process.env.REACT_APP_BOILER_BACKEND_PROTOCOL +
                                process.env.REACT_APP_BOILER_BACKEND_HOST +
                                process.env.REACT_APP_BOILER_BACKEND_PORT,
        erised:                 process.env.REACT_APP_ERISED_FRONTEND_PROTOCOL +
                                process.env.REACT_APP_ERISED_FRONTEND_HOST +
                                process.env.REACT_APP_ERISED_FRONTEND_PORT,
        minio:                  process.env.REACT_APP_MINIO_PROTOCOL +
                                process.env.REACT_APP_MINIO_HOST,
        griphook:               process.env.REACT_APP_GRIPHOOK_FRONTEND_PROTOCOL +
                                process.env.REACT_APP_GRIPHOOK_FRONTEND_HOST +
                                process.env.REACT_APP_GRIPHOOK_FRONTEND_PORT,
        akihiko:                process.env.REACT_APP_AKIHIKO_FRONTEND_PROTOCOL +
                                process.env.REACT_APP_AKIHIKO_FRONTEND_HOST +
                                process.env.REACT_APP_AKIHIKO_FRONTEND_PORT,
        boiler:                 process.env.REACT_APP_BOILER_FRONTEND_PROTOCOL +
                                process.env.REACT_APP_BOILER_FRONTEND_HOST +
                                process.env.REACT_APP_BOILER_FRONTEND_PORT,
        NIFFLER_BACKEND_URL:    process.env.REACT_APP_NIFFLER_BACKEND_PROTOCOL +
                                process.env.REACT_APP_NIFFLER_BACKEND_HOST +
                                process.env.REACT_APP_NIFFLER_BACKEND_PORT,
        DOLORES_BACKEND_URL:    process.env.REACT_APP_DOLORES_BACKEND_PROTOCOL +
                                process.env.REACT_APP_DOLORES_BACKEND_HOST +
                                process.env.REACT_APP_DOLORES_BACKEND_PORT,
        DOLORES_PRODUCTION_BACKEND_URL:
                                process.env.REACT_APP_DOLORES_PRODUCTION_BACKEND_URL ||
                                'https://backend.hr.doitforme.eu',
        CEREBRO_BACKEND_URL:    process.env.REACT_APP_CEREBRO_BACKEND_PROTOCOL
                                ? process.env.REACT_APP_CEREBRO_BACKEND_PROTOCOL +
                                process.env.REACT_APP_CEREBRO_BACKEND_HOST +
                                process.env.REACT_APP_CEREBRO_BACKEND_PORT
                                : 'https://backend.tasks.doitforme.eu',
        niffler:                process.env.REACT_APP_NIFFLER_FRONTEND_PROTOCOL +
                                process.env.REACT_APP_NIFFLER_FRONTEND_HOST +
                                process.env.REACT_APP_NIFFLER_FRONTEND_PORT,
        FAHED_FRONTEND_URL:     process.env.REACT_APP_FAHED_FRONTEND_PROTOCOL +
                                process.env.REACT_APP_FAHED_FRONTEND_HOST +
                                process.env.REACT_APP_FAHED_FRONTEND_PORT,
        dailyprofit:            process.env.REACT_APP_DAILYPROFIT_FRONTEND_PROTOCOL +
                                process.env.REACT_APP_DAILYPROFIT_FRONTEND_HOST +
                                process.env.REACT_APP_DAILYPROFIT_FRONTEND_PORT,
        timeturner:             process.env.REACT_APP_TIMETURNER_FRONTEND_PROTOCOL +
                                process.env.REACT_APP_TIMETURNER_FRONTEND_HOST +
                                process.env.REACT_APP_TIMETURNER_FRONTEND_PORT,
        verdict:                process.env.REACT_APP_VERDICT_FRONTEND_PROTOCOL +
                                process.env.REACT_APP_VERDICT_FRONTEND_HOST +
                                process.env.REACT_APP_VERDICT_FRONTEND_PORT,
        dolores:                process.env.REACT_APP_DOLORES_FRONTEND_PROTOCOL +
                                process.env.REACT_APP_DOLORES_FRONTEND_HOST +
                                process.env.REACT_APP_DOLORES_FRONTEND_PORT,
        pepperpots:             process.env.REACT_APP_PEPPERPOTS_FRONTEND_PROTOCOL +
                                process.env.REACT_APP_PEPPERPOTS_FRONTEND_HOST +
                                process.env.REACT_APP_PEPPERPOTS_FRONTEND_PORT,
        godfather:              process.env.REACT_APP_GODFATHER_FRONTEND_PROTOCOL +
                                process.env.REACT_APP_GODFATHER_FRONTEND_HOST +
                                process.env.REACT_APP_GODFATHER_FRONTEND_PORT,
        cerebro:                process.env.REACT_APP_CEREBRO_FRONTEND_PROTOCOL
                                ? process.env.REACT_APP_CEREBRO_FRONTEND_PROTOCOL +
                                process.env.REACT_APP_CEREBRO_FRONTEND_HOST +
                                process.env.REACT_APP_CEREBRO_FRONTEND_PORT
                                : 'https://tasks.doitforme.eu',
        lois:                   process.env.REACT_APP_LOIS_FRONTEND_PROTOCOL +
                                process.env.REACT_APP_LOIS_FRONTEND_HOST +
                                process.env.REACT_APP_LOIS_FRONTEND_PORT    ,
        cult:                   process.env.REACT_APP_CULT_FRONTEND_PROTOCOL +
                                process.env.REACT_APP_CULT_FRONTEND_HOST +
                                process.env.REACT_APP_CULT_FRONTEND_PORT,
        mcp:                    process.env.REACT_APP_MCP_FRONTEND_PROTOCOL +
                                process.env.REACT_APP_MCP_FRONTEND_HOST +
                                process.env.REACT_APP_MCP_FRONTEND_PORT        
      }
      
